import { get, patch } from './requests'

export const getProperty = key => propertyId => get(['properties', propertyId], { key })

export const updateProperty = key => (propertyId, payload) =>
  patch(['properties', propertyId], { key }, payload)

export const getFormattedAddress = key => propertyId =>
  get(['properties', propertyId, 'format-address'], { key })
